var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('user-form',{attrs:{"formType":_vm.formType,"pageTitle":_vm.pageTitle,"user":_vm.user},on:{"setUser":_vm.createUserAccount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }